import { Stack, Typography } from '@mui/material';
import Backdrop              from '@mui/material/Backdrop';
import CircularProgress      from '@mui/material/CircularProgress';
import { StyledPaper }       from '@styles/Shared/StyledLoaders';
import { colorTheme }        from '@styles/muiTheme';

interface LoaderProps {
  open: boolean;
  handleClose?: () => void;
  loaderText?: string;
  contained?: boolean;  // Make sure the parent element has the postion: relative to make this work
  size?: number;
  zIndex?: number;
}

export const LoaderBackdrop = ({ open, handleClose, loaderText, contained = false, size = 40, zIndex, }: LoaderProps) => (
  <div>
    <Backdrop
      open={open}
      sx={{
        position: contained ? 'absolute' : '',
        color: colorTheme.palette.common.white,
        zIndex: (theme) => zIndex ? zIndex : theme.zIndex.drawer + 1,
      }}
      onClick={handleClose}
    >
      <Stack direction="row" spacing={4}>
        <CircularProgress color="inherit" size={size} />

        {loaderText && (
          <StyledPaper elevation={3}>
            <Typography variant="h3">{loaderText}</Typography>
          </StyledPaper>
        )}
      </Stack>
    </Backdrop>
  </div>
);
